import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"

import Link from "./Link"

const Content = styled.div`
  padding: 1.5rem;
`

const Description = styled.p`
  opacity: 0.8;
  margin-bottom: 0rem;
`

const ChildrenContainer = styled.div`
  margin-top: 2rem;
`

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.isRight ? `flex-end` : `center`)};
  align-items: ${(props) => (props.isBottom ? `flex-end` : `center`)};
  background: ${(props) => props.theme.colors.cardGradient};
  border-bottom: 1px solid ${(props) => props.theme.colors.lightBorder};
  min-height: 260px;
  overflow: hidden;
`

const Title = styled.h3`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`

const Image = styled(Img)`
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 100px;
  max-width: 372px;
  max-height: 257px;
  @media (max-width: ${(props) => props.theme.breakpoints.s}) {
    max-width: 311px;
  }
`

const Card = styled(Link)`
  text-decoration: none;
  flex: 1 1 372px;
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.lightBorder};
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 4px 12px rgba(0, 0, 0, 0.05);
  margin: 1rem;
  overflow: hidden;
  transition: transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    box-shadow 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-6px);
  }
`

const ActionCard = ({
  to,
  alt,
  image,
  title,
  description,
  children,
  className,
  isRight,
  isBottom = true,
}) => {
  const isImageURL = typeof image === "string" && image.includes("http")
  return (
    <Card to={to} className={className} hideArrow={true}>
      <ImageWrapper
        isRight={isRight}
        isBottom={isBottom}
        className="action-card-image-wrapper"
      >
        {!isImageURL && <Image fixed={image} alt={alt} />}
        {isImageURL && (
          <img src={image} alt={alt} className="action-card-image" />
        )}
      </ImageWrapper>
      <Content className="action-card-content">
        <Title>{title}</Title>
        <Description>{description}</Description>
        {children && <ChildrenContainer>{children}</ChildrenContainer>}
      </Content>
    </Card>
  )
}

export default ActionCard
